import { h, ComponentChildren } from 'preact';

interface VertexLinkProps {
  href: string;
  class?: string;
  title?: string;
  children: ComponentChildren;
}

/**
 * Safe external link for user-controlled vertex URLs.
 * Always opens in a new tab with noopener/noreferrer to prevent
 * the target page from accessing window.opener.
 */
export function VertexLink({ href, class: className, title, children }: VertexLinkProps) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      class={className}
      title={title}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </a>
  );
}
